import React from "react"
import styles from "./RequiredNotice.module.css"
import { Icon } from "frontend/components/icons"
import t from "frontend/utils/translations"

const RequiredNotice = ({ required, hasError }) => {
  if (!required) {
    return null
  }
  return (
    <span className={`${styles.required} ${hasError ? styles.error : ""}`} data-testid="required-label">
      {hasError && <Icon name="exclamation-circle-filled" ariaLabel={t("form.required")} />}*{t("form.required")}
    </span>
  )
}

export default RequiredNotice
